import React 		from 'react'
import classnames 	from 'classnames'
import {
	isFinite,
	isString
} from 'lodash'
import {
	Link
} from 'gatsby'

import Icon			from '../icon'
import LinkWrapper 	from '../link-wrapper'

export const parseInternalLink = (props) => {
	const {
		link_option,
		link_internal,
		link_external,
		link_email
	} = props

	const link = link_option === 'email' && link_email ? `mailto:${ link_email }` :
		link_option === 'external' && link_external ? link_external :
			link_internal ? link_internal
				: null

	if(!link || !isString(link)){ 
		return [null, false]
	}

	const firstLetter = link.substring(0,1)

	const frontendURL = process.env.GATSBY_FRONTEND_URL
	const hasFrontendPrefix = frontendURL ? link.substring(0, frontendURL.length) === frontendURL : false

	if(hasFrontendPrefix){
		return [link.replace(frontendURL, ''), true]
	} else if(firstLetter === '#' || firstLetter === '/'){
		return [link, true]
	} else {
		return [link, false]
	}
}

export default (props) => {
	const {
		to,
		external,
		type,
		forceActive,
		icon,
		label,
		className,
		link_option,
		link_internal,
		link_external,
		link_email
	} = props

	const [link, isInternal] = to ? [to, !external] : parseInternalLink(props)

	if(!label){ return null }

	return <LinkWrapper
		to={ link }
		external={ !isInternal }
		className={ classnames('ctaButton', {
			[`ctaButton--${ type }`]: type,
			'ctaButton--hasIcon': icon,
			'ctaButton--active': forceActive
		}, className) }>
		<React.Fragment>
			{ icon ? <Icon
				icon={ icon }
				className="ctaButton-icon" /> : null }
			{ label ? <span className="ctaButton-type">{ label }</span> : null }
		</React.Fragment>
	</LinkWrapper>
}